import React from "react";
import type { StatusBadgeProps } from "../../types/index";
import { getStatus } from "../../utils/dispensationHelpers";
import * as Styles from "./StatusBadgeStyles";

const StatusBadge: React.FC<StatusBadgeProps> = ({
  dispensedAmount,
  prescribedAmount,
}) => {
  const ratio = (dispensedAmount / prescribedAmount) * 100;
  const status = getStatus(ratio);

  return (
    <Styles.StatusBadgeWrapper status={status}>
      <Styles.StatusBadge status={status}>
        {status}
      </Styles.StatusBadge>
    </Styles.StatusBadgeWrapper>
  );
};

export default StatusBadge;